import { MarkupElement, MarkupValue } from './formatElement.htmlAst';

export interface TableOfContent {
  content: string;
  level: number;
  id: string;
  children?: TableOfContent[];
}

export const headingToKey = (text: string): string =>
  `key-${text
    .toLowerCase()
    // eslint-disable-next-line no-useless-escape
    .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '') // remove all special chars
    .split(' ')
    .join('-')}`;

export const getValueRecursive = (element: MarkupElement | MarkupValue): string => {
  if (element.type !== 'text') {
    return getValueRecursive(element.children[0]);
  }

  return element.value;
};

const headingToNumber = (heading: string): number => Number(heading.replace('h', '')) - 1;

export const getTableOfContentDictionary = (markdownBodyChildren: MarkupElement[]): TableOfContent[] => {
  const headings = markdownBodyChildren
    .filter((element) => ['h2', 'h3'].includes(element.tagName) && element.properties?.toc_ignore !== 'true')
    .map((element) => {
      const content = getValueRecursive(element.children[0]);

      return {
        content: element.properties?.toc_text ?? content,
        level: headingToNumber(element.tagName),
        id: element.properties?.id ?? headingToKey(content),
      };
    });

  let currentLevel = 1;
  let currentIndex = -1;

  // if the article only have h3's
  if (!headings.find((head) => head.level === 1)) {
    return headings;
  }

  return headings.reduce((acc, current) => {
    const heading = { ...current };

    if (heading.level === 1) {
      currentIndex++;
      acc[currentIndex] = heading;
      currentLevel = 1;
    }

    if (heading.level === 2 && heading.level === currentLevel) {
      if (acc[currentIndex]?.children) {
        acc[currentIndex].children.push(heading);
      } else {
        acc[currentIndex].children = [heading];
      }
    }

    if (heading.level > currentLevel) {
      currentLevel++;

      if (acc[currentIndex]) {
        acc[currentIndex].children = [heading];
      } else {
        acc[currentIndex] = heading;
      }
    }

    return acc;
  }, [] as TableOfContent[]);
};
